export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  imageQuery: string;
}

export const articles: Article[] = [
  {
    slug: 'kakobuy-sheet-kompletny-przewodnik',
    title: 'Kakobuy Sheet — Kompletny Przewodnik po Arkuszach Produktów',
    excerpt: 'Dowiedz się, jak efektywnie korzystać z arkuszy Kakobuy, aby szybciej znajdować najlepsze produkty i oszczędzać czas na przeszukiwaniu setek ofert.',
    imageQuery: 'Modern%20spreadsheet%20interface%20on%20laptop%20screen%20with%20warm%20minimal%20desk%20setup%2C%20natural%20lighting%2C%20clean%20workspace%20aesthetic%2C%20neutral%20cream%20background%2C%20soft%20shadows%2C%20productivity%20concept'
  },
  {
    slug: 'najlepsze-produkty-kakobuy',
    title: 'Najlepsze Produkty z Kakobuy — Top Lista Finds 2026',
    excerpt: 'Przegląd najpopularniejszych produktów dostępnych przez arkusze Kakobuy. Sprawdź, co warto dodać do swojej listy zakupowej.',
    imageQuery: 'Curated%20product%20collection%20on%20minimal%20warm%20background%2C%20fashion%20items%20display%2C%20clean%20aesthetic%2C%20soft%20lighting%2C%20modern%20lifestyle%20photography%2C%20neutral%20cream%20tones'
  },
  {
    slug: 'porownanie-spreadsheet-kakobuy-cssbuy',
    title: 'Porównanie Spreadsheet: Kakobuy vs CSSBuy — Który Lepszy?',
    excerpt: 'Szczegółowe porównanie arkuszy produktów Kakobuy i CSSBuy. Która platforma oferuje lepsze listy zakupowe i więcej funkcji?',
    imageQuery: 'Side%20by%20side%20comparison%20concept%20on%20minimal%20warm%20background%2C%20clean%20aesthetic%2C%20soft%20lighting%2C%20modern%20design%2C%20neutral%20cream%20tones%2C%20two%20product%20displays'
  }
];

export const mainArticle = articles[0];